import { useContext } from 'react';
import { Card, Container, Grid, Stack, Typography } from '@mui/material';
import ArgonBox from 'component/Argon/ArgonBox';
import FormContext from './ContextForm';
import { format } from 'date-fns';
import ArgonButton from 'component/Argon/ArgonButton';

const LAST_COL_WIDTH = 148;
export default function ConfirmationPage() {
  const { formData, priceList, setPageIdx, handleSubmit } = useContext(FormContext);
  const { prefix, name, idCard, bd, pkg, nationality, policyDate } = formData;
  return (
    <Container>
      <ArgonBox mb={2}>
        <Typography variant="h4" color="primary.contrastText" fontWeight={500}>
          ซื้อประกันภัยแรงงาน
        </Typography>
        <Typography variant="body2" color="primary.contrastText">
          ยืนยันการซื้อ
        </Typography>
      </ArgonBox>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={9}>
          <Card sx={{ p: 3 }}>
            <Typography noWrap variant="h6">
              รายละเอียด
            </Typography>
            <Stack direction="row">
              <ArgonBox sx={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography noWrap variant="h6">
                  กรมธรรม์ประกันภัยสุขภาพและอุบัติเหตุส่วนบุคคล
                </Typography>
              </ArgonBox>
              <ArgonBox>
                <Typography color="text.secondary" variant="body2" textAlign="end">
                  x1
                </Typography>
              </ArgonBox>
              <ArgonBox minWidth={LAST_COL_WIDTH}>
                <Typography color="text.secondary" variant="body2" textAlign="end">
                  {`${priceList[pkg.value]}`}
                </Typography>
              </ArgonBox>
            </Stack>
            <ArgonBox>
              <TextDetail>{`${prefix.value} ${name} (${idCard})`}</TextDetail>
              <TextDetail>{`${'เกิด'} ${format(bd, 'dd/MM/yyyy')}`}</TextDetail>
              <TextDetail>{`${'สัญชาติ'} ${nationality.label}`}</TextDetail>
              <TextDetail>{`${`เริ่มความคุ้มครอง ${format(policyDate, 'dd/MM/yyyy')}`}`}</TextDetail>
              <TextDetail>{`${`ระยะความคุ้มครอง ${pkg.label}`}`}</TextDetail>
            </ArgonBox>
            <RightView primary="ราคาสุทธิ" secondary={`${priceList[pkg.value]}`} bold />
          </Card>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Card sx={{ p: 3, gap: 2 }}>
            <Typography variant="h6">เมนู</Typography>
            <ArgonButton
              onClick={() => {
                setPageIdx(0);
              }}
              color="error"
              variant="gradient"
              fullWidth
            >
              แก้ไข
            </ArgonButton>
            <ArgonButton onClick={handleSubmit} color="info" variant="gradient" fullWidth>
              เพิ่มไปที่รถเช็น
            </ArgonButton>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

function RightView({ primary, secondary, bold }) {
  return (
    <Stack direction="row" justifyContent="end">
      <ArgonBox>
        <Typography color={bold ? 'text.primary' : 'text.secondary'} variant={bold ? 'h6' : 'body2'} textAlign="end">
          {primary}
        </Typography>
      </ArgonBox>
      <ArgonBox minWidth={LAST_COL_WIDTH}>
        <Typography color="text.primary" variant={bold ? 'h6' : 'body2'} fontWeight="bold" textAlign="end">
          {secondary}
        </Typography>
      </ArgonBox>
    </Stack>
  );
}

function TextDetail({ children }) {
  return (
    <Typography variant="body2" color="text.secondary">
      {children}
    </Typography>
  );
}
